import { render, staticRenderFns } from "./Bliadver.vue?vue&type=template&id=1644417c&scoped=true&"
import script from "./Bliadver.vue?vue&type=script&lang=js&"
export * from "./Bliadver.vue?vue&type=script&lang=js&"
import style0 from "./Bliadver.vue?vue&type=style&index=0&id=1644417c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1644417c",
  null
  
)

export default component.exports